export const Types = {
  COUNTRIES_LIST: "COUNTRIES_LIST",
  LOAD_EMERGENCY_CONTACTS: "LOAD_EMERGENCY_CONTACTS"
};
